module.exports = __webpack_public_path__ + "static/media/logo-part-2.6c418c27.svg";